<template>
  <div slot-scope="{ form, methods }" class="space-y-6">

    <vehicles-card :form="form" :methods="methods" />
    
    <div class="card">
      <div class="card-header">
        Conditions
      </div>
      <div class="p-6">
        <label class="form-label">Trigger this automation when a vehicle:</label> 
        <radio-group
          v-model="form.condition"
          :options="[
            { value: 0, label: 'Leaves' },
            { value: 1, label: 'Enters' },
            { value: 2, label: 'Enters or Leaves' },
          ]" />

        <multiselect 
          class="mt-4"
          :options="areas.data" 
          label="areaname" 
          track-by="id" 
          :value="selectedArea" 
          @input="handleAreaSelect" 
          @remove="handleAreaSelect">
          <template slot="option" slot-scope="props">
            <div>{{ props.option.areaname }}</div>
            <div class="mt-1 text-sm text-gray-500 ">{{ props.option.areano }}</div>
          </template>
        </multiselect>
      </div>
    </div>

    <schedule-card :form="form" :methods="methods" />

    <contacts-card :form="form" :methods="methods" />

    <driver-device-card :form="form" :methods="methods" />
    
    <monitor-card :form="form" :methods="methods" />
    
  </div>
</template>

<script>
  import AreaSelect from '@/components/AreaSelect'
  import Multiselect from 'vue-multiselect'
  import ContactsCard from '@/views/automations/components/ContactsCard'
  import DriverDeviceCard from '@/views/automations/components/DriverDeviceCard'
  import MonitorCard from '@/views/automations/components/MonitorCard'
  import ScheduleCard from '@/views/automations/components/ScheduleCard'
  import VehiclesCard from '@/views/automations/components/VehiclesCard'
  
  export default {
    name: 'AreaChange',
    
    components: { 
      AreaSelect,
      Multiselect,
      ContactsCard,
      DriverDeviceCard,
      MonitorCard,
      ScheduleCard,
      VehiclesCard
    },

    props: ['form', 'methods'],

    created () {
      this.getAreas()
    },

    computed: {
      selectedArea () {
        if (!this.form.areas[0]) {
          return null
        } else {
          return this.areas.data.find((area) => {
            if (this.form.areas[0].id) {
              return area.id === this.form.areas[0].id
            } else {
              return area.id === this.form.areas[0]
            }
          })
        }
      }
    },

    data () {
      return {
        areas: {
          data: []
        }
      }
    },

    methods: {
      async getAreas () {
        try {
          const { data } = await this.$api.get(`account/${this.$route.params.account}/areas`, {
            params: {
              page: this.$route.query.page || 1,
              limit: 500
            }
          })
          this.areas = data.areas
          this.loading = false
        } catch (error) {
          console.error(error)
        }
      },

      handleAreaSelect (val) {
        if (val === null) { 
          this.form.areas = [] 
        } else {
          this.form.areas = [val]
        }
      }
    }
  }
</script>